import { useEffect, useState } from "react";

/**
 * Slides up from the bottom when one or more badges are newly earned.
 * Auto-dismisses after 5 seconds; can also be dismissed manually.
 *
 * Props:
 *   badges — array of { slug, name, icon, description }
 */
const BadgeToast = ({ badges }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!badges?.length) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(t);
  }, [badges]);

  if (!visible || !badges?.length) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 left-1/2 z-50 w-full max-w-sm -translate-x-1/2 animate-slide-up px-4"
    >
      <div className="rounded-2xl border border-brand-glow/40 bg-slate-900 shadow-xl shadow-black/50 px-5 py-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-glow">
              {badges.length === 1 ? "Badge unlocked!" : `${badges.length} badges unlocked!`}
            </p>
            <div className="mt-2 flex flex-col gap-1.5">
              {badges.map((b) => (
                <div key={b.slug} className="flex items-center gap-2">
                  <span className="text-xl">{b.icon}</span>
                  <div>
                    <p className="text-sm font-semibold text-white">{b.name}</p>
                    <p className="text-xs text-white/50">{b.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button
            type="button"
            onClick={() => setVisible(false)}
            aria-label="Dismiss"
            className="mt-0.5 text-white/30 transition hover:text-white/70"
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BadgeToast;
